import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls"
import * as api from "../../../common/manipurCommon/API";
import Utils from "../../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Select from "react-select";
import Swal from "sweetalert2";

const Competitions = () => {

    const [compsList, setCompsList] = useState<any[]>([]);
    const [compTypeList, setCompTypeList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [sportTypeList, setSportTypeList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [athleteId, setAthleteId] = useState([]);
    const [compsId, setCompsId] = useState("");
    const [compsName, setCompsName] = useState("");
    const [compsType, setCompsType] = useState("");
    const [compsStatus, setCompsStatus] = useState("");
    const [compVenue, setCompVenue] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [sportId, setSportId] = useState("");
    const [sportTypeId, setSportTypeId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [openSportLstModal, setOpenSportLstModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchCompetitions() {
            setIsLoading(true);
            const compResponse = await func.competitions(null);
            setCompsList(Array.isArray(compResponse) ? compResponse : [])
            setIsLoading(false);
        }
        fetchCompetitions();
    }, [])

    const filteredData = compsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compNameRender = (rowData) => {
        return <span>{rowData.competitionName}</span>
    };

    const compTypeNameRender = (rowData) => {
        return <span>{rowData.competitionTypeName}</span>
    };

    const compVenueNameRender = (rowData) => {
        return <span>{rowData.venue}</span>
    };

    const startDateRender = (rowData) => {
        return <span>{formatDate(rowData.startDate)}</span>
    }

    const endDateRender = (rowData) => {
        return <span>{formatDate(rowData.endDate)}</span>
    }

    const compStatus = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    }

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const toInputDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${year}-${month}-${day}`; // <-- input expects this format
    };

    async function newCompetitions() {
        setOpenModal(true);
        setIsEdit(false)
        setCompsName("");
        setCompsType("");
        setCompVenue("");
        setStartDate("");
        setEndDate("");
        setOpenSportLstModal(false)
        const compTypeResponse = await func.competitionType(null);
        setCompTypeList(Array.isArray(compTypeResponse) ? compTypeResponse : [])
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editCompetition(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const compId = rowData.competitionId;
        return (
            <Link to="#" onClick={() => deleteCompetition(compId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editCompetition(rowData: { competitionId: any; }) {
        const comptypid = rowData.competitionId;
        setIsEdit(true)
        const compTypeResponse = await func.competitionType(null);
        setCompTypeList(Array.isArray(compTypeResponse) ? compTypeResponse : [])
        const getDetails = await func.competitions(comptypid);
        setCompsId(getDetails.competitionId);
        setCompsName(getDetails.competitionName);
        setCompsType(getDetails.competitionTypeId);
        setCompVenue(getDetails.venue);
        setCompsStatus(getDetails.status);
        setStartDate(toInputDate(getDetails.startDate));
        setEndDate(toInputDate(getDetails.endDate));
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateCompetitions();
            } else {
                const formData = new FormData();
                formData.append("name", compsName);
                formData.append("type", compsType);
                formData.append("venue", compVenue);
                formData.append("startDate", startDate);
                formData.append("endDate", endDate);
                const createComps = api.competitions;
                fetch(createComps, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    sprtCochMdl();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    async function sprtCochMdl() {
        const compResponse = await func.competitions(null);
        setCompsList(Array.isArray(compResponse) ? compResponse : [])
        const sprtResponse = await func.competitionSport(null);
        setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
        const athleteResponse = await func.listActiveAthletes();
        setAthleteList(Array.isArray(athleteResponse) ? athleteResponse : [])
        const compSprtTypeResponse = await func.competitionSportType(null);
        setSportTypeList(Array.isArray(compSprtTypeResponse) ? compSprtTypeResponse : [])
        setOpenModal(false)
        setOpenSportLstModal(true)
    }

    function saveSportLst(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            const formData = new FormData();
            formData.append("competitionId", compsId);
            formData.append("sportId", sportId);
            formData.append("sportTypeId", sportTypeId);
            formData.append("athlete", JSON.stringify(athleteId.map(Number)));
            // formData.append("totalParticipants", totParticipants);
            const createSportList = api.sportList;
            fetch(createSportList, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
        }
    }

    function updateCompetitions() {
        const formData = new FormData();
        formData.append("name", compsName);
        formData.append("type", compsType);
        formData.append("venue", compVenue);
        formData.append("startDate", startDate);
        formData.append("endDate", endDate);
        formData.append("status", compsStatus);
        const updateCompTyp = api.competitions + "/" + compsId;
        fetch(updateCompTyp, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteCompetition(compid: string) {
        const delteComp = api.competitions + "/" + compid + "/0";
        fetch(delteComp, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Competitions</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newCompetitions() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Competition Type">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionName"
                                                header="Competition Name"
                                                body={compNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="competitionTypeName"
                                                header="Competition Type Name"
                                                body={compTypeNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="venue"
                                                header="Competition Venue"
                                                body={compVenueNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="startDate"
                                                header="Start Date"
                                                body={startDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="endDate"
                                                header="End Date"
                                                body={endDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={compStatus}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="lg"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Competitions</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="competitionName"
                                            placeholder="Enter Competitions"
                                            required
                                            value={compsName}
                                            onChange={(e) => setCompsName(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition Type</label>
                                        <Select
                                            value={compTypeList.find(cmp => cmp.competitionTypeId === compsType) ? {
                                                value: compsType,
                                                label: compTypeList.find(cmp => cmp.competitionTypeId === compsType).competitionTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompsType(e.value);
                                            }}
                                            required
                                            placeholder="Select Skill"
                                            options={compTypeList.map(cmp => ({
                                                value: cmp.competitionTypeId,
                                                label: cmp.competitionTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition Venue</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="competitionName"
                                            placeholder="Enter Competitions"
                                            required
                                            value={compVenue}
                                            onChange={(e) => setCompVenue(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="startDate"
                                            placeholder="Enter Start Date"
                                            required
                                            value={startDate}
                                            onChange={(e) => setStartDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="endDate"
                                            placeholder="Enter End Date"
                                            required
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="col-lg-6 mt-10">
                                            <div className="row">
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <label className="form-label">Status</label>
                                                </div>
                                                <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                    <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                        <input
                                                            className="form-check-input text-end"
                                                            type="checkbox"
                                                            checked={compsStatus === '1'}
                                                            id="scdlStatus"
                                                            onChange={(e) => {
                                                                setCompsStatus(e.target.checked ? '1' : '0')
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}

            {openSportLstModal && (
                <Modal
                    show={openSportLstModal}
                    size="lg"
                    centered
                >
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">Add Sport List</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Competition</label>
                                        <Select
                                            value={compsList.find(comp => comp.competitionId === compsId) ? {
                                                value: compsId,
                                                label: compsList.find(comp => comp.competitionId === compsId).competitionName
                                            } : null}
                                            onChange={async (e) => {
                                                setCompsId(e.value);
                                            }}
                                            required
                                            placeholder="Select Competition"
                                            options={compsList.map(comp => ({
                                                value: comp.competitionId,
                                                label: comp.competitionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport Type</label>
                                        <Select
                                            value={sportTypeList.find(spTyp => spTyp.competitionSportsTypeId === sportTypeId) ? {
                                                value: sportTypeId,
                                                label: sportTypeList.find(spTyp => spTyp.competitionSportsTypeId === sportTypeId).SportTypeName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportTypeId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport Type"
                                            options={sportTypeList.map(spTyp => ({
                                                value: spTyp.competitionSportsTypeId,
                                                label: spTyp.SportTypeName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport</label>
                                        <Select
                                            value={sportList.find(sprt => sprt.competitionsportsId === sportId) ? {
                                                value: sportId,
                                                label: sportList.find(sprt => sprt.competitionsportsId === sportId).sportName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport"
                                            options={sportList.map(sprt => ({
                                                value: sprt.competitionsportsId,
                                                label: sprt.sportName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-6 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Add Athletes</label>
                                        <Select
                                            isMulti={!isEdit}
                                            value={Array.isArray(athleteList)
                                                ? athleteList
                                                    .filter(athlt => athleteId.includes(athlt.userId))
                                                    .map(athlt => ({
                                                        value: athlt.userId,
                                                        label: athlt.athleteName
                                                    }))
                                                : []
                                            }
                                            onChange={(selectedOptions) => {
                                                // const selectedIds = selectedOptions.map(option => option.value);
                                                const selectedIds = Array.isArray(selectedOptions)
                                                    ? selectedOptions.map(option => option.value)
                                                    : selectedOptions
                                                        ? [selectedOptions.value]
                                                        : [];
                                                setAthleteId(selectedIds);
                                            }}
                                            options={Array.isArray(athleteList)
                                                ? athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))
                                                : []
                                            }
                                        />
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={sportStatus === '1'}
                                                        id="scdlStatus"
                                                        onChange={(e) => {
                                                            setSportStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                            </div>
                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={saveSportLst}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    )
};

export default Competitions;